import { render, staticRenderFns } from "./GroupRules.vue?vue&type=template&id=45730f1a&scoped=true&"
import script from "./GroupRules.vue?vue&type=script&lang=js&"
export * from "./GroupRules.vue?vue&type=script&lang=js&"
import style0 from "./GroupRules.vue?vue&type=style&index=0&id=45730f1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45730f1a",
  null
  
)

export default component.exports